import authReducer from './authReducer'
import projectReducer from './projectReducer'
import userReducer from './userReducer'
import billingReducer from './billingReducer'
import { combineReducers } from 'redux'
import { firestoreReducer } from 'redux-firestore';
import { firebaseReducer } from 'react-redux-firebase'
import journalReducer from './journalReducer';

const rootReducer = combineReducers({
  auth: authReducer,
  project: projectReducer,
  journal: journalReducer,
  firestore: firestoreReducer,
  user: userReducer,
  firebase: firebaseReducer,
  billing: billingReducer
});

export default rootReducer

// the key name will be the data property on the state object


// WEBPACK FOOTER //
// ./src/store/reducers/rootReducer.js